import React from 'react';
import { connect } from 'react-redux';
import URI from 'urijs';

// components
import AgentCard from '../../partials/agent-card/agent-card';

// modules
import styles from '../Containers.module.scss';

function AgentResult({ record, searchURI }) {
  return (
    <AgentCard
      data={record}
      className={styles.searchResult}
      searchURI={searchURI}
      label={getAgentLabel(record)}
    />
  );
}

function getAgentLabel(data) {
  const { memberType } = data;
  var label = 'Agent';

  if (memberType === 'service_provider') {
    label = 'Provider';
  }

  return label;
}

export default connect((state, props) => {
  const { pathname, search = {} } = state.routing.location;
  return {
    searchURI: pathname && URI(pathname).search(search).toString()
  };
}, {})(AgentResult);



// WEBPACK FOOTER //
// ./src/containers/AgentSearch/AgentResult.js